export { default as CreditNoteSlot } from './CreditNoteSlot';
